<template>
  <section class="my-5">

    <div class="form-content">
      <h3>マナビス・ショッピングクラブ会員登録申込開始のお知らせ</h3>
      <p class="my-5">この度は、マナビス・ショッピングクラブ会員登録にお申込みいただき、誠にありがとうございます。</p>
      <p class="my-5">本メールを受信した時点では、会員登録は完了しておりません。</p>
      <p class="my-5">登録を完了するためには、申込者情報の登録及び商品ご購入の手続きを行って下さい。</p>
      <p class="my-5">2023/00/00 00:00:00までに下記URLをクリックするか、ブラウザのアドレス欄にコピーしていただき、表示される画面にて登録情報の入力と商品購入手続きにお進みください。</p>
      <p class="my-5">【登録 URL】<br><router-link to="/mock/influencer/registration">https://www.manavis-cosme.co.jp/web/#/influencer/registration/◯◯◯</router-link></p>
      <p class="my-5">
        ------------------------------------------------------------------------------------------<br>
        ※本メールは、配信専用のアドレスで配信されているため、返信いただいても返答いたしかねますのであらかじめご了承ください。<br>
        ※本メールの内容についてのお問い合わせは、下記のお問い合わせ窓口まで連絡をお願いいたします。<br>
        <br>
        株式会社マナビス化粧品 お問い合わせ窓口<br>
        メール <a href="mailto:mc-info@manavis-cosme.co.jp">mc-info@manavis-cosme.co.jp</a><br>
        ------------------------------------------------------------------------------------------
      </p>
    </div>
  </section>

</template>
<script>

export default {
  mounted() {
    window.scroll(0, 0);
  }
};

</script>
